import holyDeathDefaults from '../riding-death-shop/config.js';

export default {
  includes: ['shopify-generic'],
  ...holyDeathDefaults,
};
